import React, { PureComponent } from "react";
import PageHeaderWrapper from "../../../../components/PageHeaderWrapper";
//import GetAllFormFields from '../../../../components/_utils/formUtils'
import { FormUtils as GetAllFormFields } from "sz-react-utils";
import { Button, Card, Form, notification, Tabs } from "antd";
import _ from "lodash";

import { hideLoader, showLoader } from "../../../../modules/actions";
import Request, { API_URL } from "../../../../request";
import { connect } from "react-redux";

const TabPane = Tabs.TabPane;
// following variables needed for update country
let docLoaded = null;
let boardId = null;

@Form.create()
class AddBoard extends PureComponent {
  callback = (key) => {
    let inputTypes = this.state.inputTypes;

    if (boardId && inputTypes[key - 1] && !inputTypes[key - 1].opened) {
      inputTypes[key - 1].opened = true;
      let tempObj = {};
      _.each(inputTypes[key - 1].fields, (v, k) => {
        tempObj[v.key] = docLoaded[v.key];
      });
      setTimeout(() => {
        this.props.form.setFieldsValue(tempObj);
      }, 10);
    }
  };
  
  getAllRankings = (data) =>{
    Request.getBoardRankingDetailsByType({
      type:data
    }).then((data) =>{
      data = data.data.reduce((total,val) =>{
          total.push({
            _id: val._id,
            key: val._id,
            display: val.BoardRankingName,
          })
          return total
      },[])
      let inputTypes = this.state.inputTypes;
        inputTypes[0]["fields"][3].options = data;
        this.setState({ inputTypes: inputTypes });
        this.refreshFxn();
    })
  }

  getAllCategories = (data) =>{
    Request.getBoardCategoryDetailsByType({
      type:data
    }).then((result) =>{
      data = result.data.reduce((total,val) =>{
          total.push({
            _id: val._id,
            key: val._id,
            display: val.BoardCategoryName,
          })
          return total
      },[])
      let inputTypes = this.state.inputTypes;
        inputTypes[0]["fields"][4].options = data;
        this.setState({ inputTypes: inputTypes });
        this.refreshFxn();
    })
  }
  handleSubmit = (e) => {
    const { dispatch, form, afterSave } = this.props;

    e.preventDefault();
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData);
        if (boardId) {
          values = { ...values, _id: boardId };

          dispatch(showLoader());

          let x = await Request.updateBoard(values);

          dispatch(hideLoader());

          if (!x.error) {
            notification.success({
              message: "Success",
              description: x.msg,
            });
          } else {
            notification.error({
              message: "Error Saving",
              description: x.msg,
            });
          }
        } else {
          dispatch(showLoader());

          let x = await Request.addBoard(values);

          dispatch(hideLoader());

          if (!x.error) {
            notification.success({
              message: "Success",
              description: x.msg,
            });

            if (afterSave) {
              afterSave();
            }
            form.resetFields();
            // dispatch('/all-countries')
          } else {
            notification.error({
              message: "Error Saving",
              description: x.msg,
            });
          }
        }
      }
    });
  };
  constructor(props) {
    super(props);
    this.state = {
      showSave: 1,
      showFiles: 0,
      refreshChild: false,
      typeBoard:false,
      inputTypes: [
        {
          tabTitle: "Basic Details",
          fields: [
            {
              label: "Name",
              key: "boardName",
              required: true,
            },
            {
              label:"Type",
              key:'type',
              type:"select",
              options:['Board', 'University'],
              required:true,
              onChange:v=>{
                let inputTypes = this.state.inputTypes;
                if(v === 'Board') {
                  inputTypes[0].fields[2].hidden = false
                  inputTypes[0].fields[3].hidden = true
                  inputTypes[0].fields[6].hidden = true
                  inputTypes[0].fields[7].hidden = true
                }else {
                  inputTypes[0].fields[2].hidden = true
                  inputTypes[0].fields[3].hidden = false
                  inputTypes[0].fields[6].hidden = false
                  inputTypes[0].fields[7].hidden = false
                }
                this.props.form.setFieldsValue({type:v});
                this.getAllRankings(v)
                this.getAllCategories(v)
              }
            },
            {
              label:"Type",
              hidden:true,
              key:'BoardType',
              type:"select",
              options:['Centre Board', 'State Board'],
              required:true,
              onChange:v=>{
                this.props.form.setFieldsValue({BoardType:v});
              }
            },
            {
              label:"Ranking",
              key:'BoardRankingId',
              type:"select",
              hidden:true,
              options:[],
              required:true,
              onChange:v=>{
                this.props.form.setFieldsValue({BoardRankingId:v});
              }
            },
            {
              label:"Category",
              key:'BoardCategoryId',
              type:"select",
              options:[],
              required:true,
              onChange:v=>{
                this.props.form.setFieldsValue({BoardCategoryId:v});
              }
            },
            {
              label: "Select Country ",
              key: "countryId",
              required: true,
              type: "select",
              showSearch: true,
              options: [],
              onChange: (v) => {
                this.props.form.setFieldsValue({
                  countryId: v,
                  stateId: null,
                  cityId: null,
                });
                this.loadStates(v);
              },
            },
            {
              label: "Select State",
              key: "stateId",
              required: true,
              type: "select",
              showSearch: true,
              hidden:true,
              options: [],
              onChange: (v) => {
                this.props.form.setFieldsValue({
                  stateId: v,
                  cityId: null,
                });
                this.loadCities(v);
              },
            },
            {
              label: "Select City",
              key: "cityId",
              required: true,
              hidden:true,
              showSearch: true,
              type: "select",
              options: [],
              onChange: (v) => {
                this.props.form.setFieldsValue({
                  cityId: v,
                });
              },
            }
          ],
        }
      ]
    };
    this.loadCountries();
  }

  setFormValues = async (boardId) => {
    try {
      let { doc } = await Request.getBoard(boardId);

      if (doc) {
        docLoaded = doc;

        let inputTypes = this.state.inputTypes;

        this.getAllCategories(docLoaded.type);
        this.getAllRankings(docLoaded.type);
        this.loadStates(docLoaded.countryId);
        this.loadCities(docLoaded.stateId);
        if(docLoaded.type === 'Board') {
          inputTypes[0].fields[2].hidden = false
          inputTypes[0].fields[3].hidden = true
          inputTypes[0].fields[6].hidden = true
          inputTypes[0].fields[7].hidden = true
        }else {
          inputTypes[0].fields[2].hidden = true
          inputTypes[0].fields[3].hidden = false
          inputTypes[0].fields[6].hidden = false
          inputTypes[0].fields[7].hidden = false
        }
        setTimeout(() => {
          this.props.form.setFieldsValue(docLoaded);
        }, 1000)
        
      }
    } catch (e) {
      console.log(e);
    }
  };

  loadCountries = () => {
    let params = {
      results: 200,
      sortField: "countryName",
      sortOrder: "ascend",
    };
    Request.getCountriesWithoutAuth({ ...params })
      .then((resp) => {
        resp.data = resp.data.reduce((temp, vv) => {
          temp.push({ _id: vv._id, display: vv.countryName });
          return temp;
        }, []);
        let inputTypes = this.state.inputTypes;
        inputTypes[0]["fields"][5].options = resp.data;
        this.setState({ inputTypes: inputTypes });
        this.refreshFxn();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  loadStates = (id) => {
    Request.loadStates(id)
      .then((daa) => {
        daa.result = daa.result.reduce((total, val) => {
          total.push({
            _id: val._id,
            key: val._id,
            display: val.stateName,
          });
          return total;
        }, []);

        let inputTypes = this.state.inputTypes;
        inputTypes[0]["fields"][6].options = daa.result;
        this.setState({ inputTypes: inputTypes });
        this.refreshFxn();
      })
      .catch((err) => {});
  };

  loadCities = (id) => {
    Request.loadCities(id)
      .then((daa) => {
        daa.result = daa.result.reduce((total, val) => {
          total.push({
            _id: val._id,
            key: val._id,
            display: val.cityName,
          });
          return total;
        }, []);
        let inputTypes = this.state.inputTypes;
        inputTypes[0]["fields"][7].options = daa.result;
        this.setState({ inputTypes: inputTypes });
        this.refreshFxn();
      })
      .catch((err) => {});
  };

  refreshFxn = () => {
    this.setState({ refreshChild: !this.state.refreshChild });
  };

  componentDidMount() {
    let searchParams = new URLSearchParams(this.props.search);
    boardId = searchParams.get("_id");

    if (boardId) {
      this.setState({ showFiles: 1 });
      this.setFormValues(boardId);
    }
  }

  render() {
    const {
      formOnly,
      form: { getFieldDecorator },
    } = this.props;

    let form = (
      <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
        <Card bordered={true}>
          <Button
            type="primary"
            htmlType="submit"
            style={{ marginBottom: 10 }}
            loading={this.props.loading}
          >
            SAVE
          </Button>
          <Tabs onChange={this.callback} type="card">
            {this.state.inputTypes.map((itype, key) => {
              return (
                <TabPane tab={itype.tabTitle} key={key + 1}>
                  <GetAllFormFields
                    apiurl={API_URL}
                    inputSchema={this.state.inputTypes[key]}
                    refresh={this.refreshFxn}
                    getFieldDecorator={getFieldDecorator}
                  />
                </TabPane>
              );
            })}
          </Tabs>
        </Card>
      </Form>
    );

    return (
      <React.Fragment>
        {!formOnly ? (
          <PageHeaderWrapper title={"Add New Board"}>{form}</PageHeaderWrapper>
        ) : (
          form
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ global, router }) => ({
  loading: global.buttonLoading,
  categories: global.categories,
  search: router.location.search,
});
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddBoard);
